
import EkonomiskAnalysKontodelarQuery, {
  IKontodelar,
} from '../../../../../../../Queries/EkonomiskAnalysKontodelarQuery/EkonomiskAnalysKontodelarQuery';
import EkonomiskAnalysKontobegreppQuery, {
  IKontoValues,
} from '../../../../../../../Queries/EkonomiskAnalysKontobegreppQuery/EkonomiskAnalysKontobegreppQuery';
import { IUIUrval } from '../../../../../../../../../../../../Types/UrvalTypes';

interface IProps {
  urval: IUIUrval | null;
  children: (
    kontodelarValues: IKontodelar,
    kontobegreppValues: IKontoValues[]
  ) => React.ReactElement<any>;
}

const EkonomiskAnalysSimpleUrvalSuggestionContext = (props: IProps) => (
  <EkonomiskAnalysKontodelarQuery loadingComponent={null}>
    {kontodelarValues => (
      <EkonomiskAnalysKontobegreppQuery
        urval={props.urval}
        loadingComponent={null}
      >
        {kontobegreppValues =>
          props.children(kontodelarValues, kontobegreppValues)
        }
      </EkonomiskAnalysKontobegreppQuery>
    )}
  </EkonomiskAnalysKontodelarQuery>
);

export default EkonomiskAnalysSimpleUrvalSuggestionContext;
